<template>
  <video ref="videoPlayer" class="video-js vjs-theme-fantasy"></video>
</template>

<script>
import videojs from 'video.js'
// import axios from 'axios'
require('video.js/dist/video-js.css')
require('@videojs/themes/dist/fantasy/index.css')
require('videojs-contrib-quality-levels')
require('videojs-http-source-selector')

export default {
  name: 'VideoJS',
  data () {
    return {
      player: null,
      errors: [],
      videoOptions: {
        autoplay: true,
        controls: true,
        fluid: true,
        preload: 'auto',
        aspectRatio: '16:9',
        poster: null,
        sources: []
      }
    }
  },
  mounted () {
    this.playStream()
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    playStream () {
      this.videoOptions.sources = [{
        src: 'https://embedlp.becdn.net/' + this.$route.query.c + '.m3u8',
        type: 'application/x-mpegurl'
      }]
      this.videoOptions.poster = ''
      this.videoOptions.liveui = true
      this.videoOptions.plugins = {
        httpSourceSelector:
        {
          default: '360p'
        }
      }
      this.player = videojs(this.$refs.videoPlayer, this.videoOptions, function onPlayerReady () {
      }).httpSourceSelector()
    }
  }
}
</script>
<style lang="scss">
.vjs-icon-cog {
  font-size: 18px !important;
}
.vjs-theme-fantasy {
  --vjs-theme-fantasy--primary: #1D87DA !important;
  --vjs-theme-fantasy--secondary: #fff;
}
</style>
